import { registerAction } from '../../Action'

const SET_LOADER = 'SET_LOADER'

const reducer = (state = {}, action) => {
  const parent = Object.keys(action.payload)[0]
  const value = Object.values(action.payload)[0]

  let update = { [parent]: value }

  if (typeof value === 'object') {
    update = {
      [parent]: {
        ...(state.loaders && state.loaders[parent]),
        ...value,
      },
    }
  }

  return {
    ...state,
    loaders: {
      ...state.loaders,
      ...update,
    },
  }
}

const setLoader = registerAction(SET_LOADER, { reducer })

export default setLoader
